import { render, staticRenderFns } from "./CourseDialog.vue?vue&type=template&id=b3b6e770&scoped=true"
import script from "./CourseDialog.vue?vue&type=script&lang=js"
export * from "./CourseDialog.vue?vue&type=script&lang=js"
import style0 from "./CourseDialog.vue?vue&type=style&index=0&id=b3b6e770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b6e770",
  null
  
)

export default component.exports